import { type Supplier } from "@entities/supplier";

export const mockSuppliers: Supplier[] = [
  // Backofenhersteller & Service
  {
    id: "sup-1",
    name: "Wiesheu GmbH",
    tenant_id: "1",
    street: "Daimlerstraße 10",
    zip: "75015",
    city: "Bretten",
    country: "Deutschland",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "sup-2",
    name: "Debag Deutsche Backofenbau",
    tenant_id: "1",
    street: "Gottlieb-Daimler-Straße 10",
    zip: "35423",
    city: "Lich",
    country: "Deutschland",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "sup-3",
    name: "Rational AG",
    tenant_id: "1",
    street: "Siegfried-Meister-Straße 1",
    zip: "86899",
    city: "Landsberg am Lech",
    country: "Deutschland",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "sup-4",
    name: "Miwe Michael Wenz GmbH",
    tenant_id: "1",
    street: "Michael-Wenz-Straße 2-10",
    zip: "97450",
    city: "Arnstein",
    country: "Deutschland",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },

  // Kältetechnik
  {
    id: "sup-5",
    name: "Liebherr Hausgeräte",
    tenant_id: "1",
    street: "Memminger Straße 77",
    zip: "88416",
    city: "Ochsenhausen",
    country: "Deutschland",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "sup-6",
    name: "Viessmann Kühlsysteme",
    tenant_id: "1",
    street: "Viessmannstraße 1",
    zip: "35108",
    city: "Allendorf",
    country: "Deutschland",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "sup-7",
    name: "Nordcap GmbH & Co. KG",
    tenant_id: "1",
    street: "Nordkap 1",
    zip: "26835",
    city: "Hesel",
    country: "Deutschland",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },

  // Spültechnik
  {
    id: "sup-8",
    name: "Winterhalter Gastronom GmbH",
    tenant_id: "1",
    street: "Winterhalterstraße 2-12",
    zip: "88074",
    city: "Meckenbeuren",
    country: "Deutschland",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "sup-9",
    name: "Hobart GmbH",
    tenant_id: "1",
    street: "Robert-Bosch-Straße 17",
    zip: "77656",
    city: "Offenburg",
    country: "Deutschland",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },

  // Kassensysteme
  {
    id: "sup-10",
    name: "Vectron Systems AG",
    tenant_id: "1",
    street: "Willy-Brandt-Weg 41",
    zip: "48155",
    city: "Münster",
    country: "Deutschland",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "sup-11",
    name: "Schultes Microcomputervertriebs",
    tenant_id: "1",
    street: "Alter Teichweg 25",
    zip: "22049",
    city: "Hamburg",
    country: "Deutschland",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },

  // Zutaten-Lieferanten (regional)
  {
    id: "sup-12",
    name: "Mühle Mannheim GmbH",
    tenant_id: "1",
    street: "Mühlweg 12",
    zip: "68159",
    city: "Mannheim",
    country: "Deutschland",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "sup-13",
    name: "Backzutaten Heidelberg",
    tenant_id: "1",
    street: "Bergheimer Straße 45",
    zip: "69115",
    city: "Heidelberg",
    country: "Deutschland",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "sup-14",
    name: "Milchwerk Rhein-Neckar",
    tenant_id: "1",
    street: "Industriestraße 88",
    zip: "68519",
    city: "Viernheim",
    country: "Deutschland",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "sup-15",
    name: "Ölmühle Pfalz",
    tenant_id: "1",
    street: "Landauer Straße 5",
    zip: "67433",
    city: "Neustadt",
    country: "Deutschland",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },

  // Verpackung
  {
    id: "sup-16",
    name: "Packwell GmbH",
    tenant_id: "1",
    street: "Verpackungsweg 3",
    zip: "68309",
    city: "Mannheim",
    country: "Deutschland",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "sup-17",
    name: "Bäckertüten Direkt",
    tenant_id: "1",
    street: "Papierstraße 22",
    zip: "76227",
    city: "Karlsruhe",
    country: "Deutschland",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },

  // Sonstiges
  {
    id: "sup-18",
    name: "Berufskleidung Müller",
    tenant_id: "1",
    street: "Textilweg 8",
    zip: "68167",
    city: "Mannheim",
    country: "Deutschland",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "sup-19",
    name: "Reinigungsmittel Schmidt",
    tenant_id: "1",
    street: "Hygienering 15",
    zip: "67063",
    city: "Ludwigshafen",
    country: "Deutschland",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "sup-20",
    name: "Gastro-Elektro Kurpfalz",
    tenant_id: "1",
    street: "Elektrostraße 9",
    zip: "68165",
    city: "Mannheim",
    country: "Deutschland",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];
